import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-wildflower-info',
  templateUrl: './wildflower-info.component.html',
  styleUrls: ['./wildflower-info.component.css']
})
export class WildflowerInfoComponent {

}
